import { render } from "./TodoList.vue?vue&type=template&id=f209bb3e"
import script from "./TodoList.vue?vue&type=script&lang=ts"
export * from "./TodoList.vue?vue&type=script&lang=ts"
script.render = render

export default script